"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManageNumericField = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _AddBox = _interopRequireDefault(require("@material-ui/icons/AddBox"));
var _IndeterminateCheckBox = _interopRequireDefault(require("@material-ui/icons/IndeterminateCheckBox"));
var _AllInclusive = _interopRequireDefault(require("@material-ui/icons/AllInclusive"));
var _ManageTextField2 = require("./ManageTextField");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Extends ManageTextField to handle integer numbers, with optional +/- buttons, and optionally an infinity button.  When a button is pressed,
 * a timer starts, and if nothing else changes after timeout, the commit callback is sent.
 * 
 * All the same props from ManageTextField are available, with the addition of optional props:
 * 
 *  hasInfinity: to allow for an infinite number (with button shown as the infinity symbol) - default false (represented by -1 or null internally)
 *  hasNegative: true to allow negative numbers (if true, infinity represented by null.  If false, infinity represented by -1)
 *  commitTimeout: milliseconds to wait on button presses for commit (default 1000)
 *  hideButtons: to hide the +/- buttons
 *  infinityText: text for the infinity value, default = "Unlimited"
 *  justify: horizontal justify, default 'center'
 *  minValue: if set, value is coerced to this minimum value
 *  maxValue: if set, value is coerced to this maximum value
 *  increment: if set, the value is coerced to multiples of this increment, and the buttons add or subtract this increment
 */

var COMMIT_TIMEOUT_DEFAULT = 1000;
var ManageNumericField = exports.ManageNumericField = /*#__PURE__*/function (_ManageTextField) {
  function ManageNumericField(props) {
    var _this;
    _classCallCheck(this, ManageNumericField);
    _this = _callSuper(this, ManageNumericField, [props]);
    _defineProperty(_this, "_hasInfinity", false);
    _defineProperty(_this, "_hasNegative", false);
    _defineProperty(_this, "_commitTimer", null);
    _defineProperty(_this, "_commitTimeout", COMMIT_TIMEOUT_DEFAULT);
    _defineProperty(_this, "_justify", 'center');
    _defineProperty(_this, "_infinityText", "Unlimited");
    _defineProperty(_this, "_increment", 1);
    _defineProperty(_this, "stringForVal", function (val) {
      if (val === undefined) return "";else if (val === null)
        //nulls are infinity
        return _this._infinityText;else if (val < 0 && !_this._hasNegative)
        //negative values are infinity if we don't have negative
        return _this._infinityText;else return _this.interpretVal(val.toString()).toString();
    });
    //Stop and clear any existing timer
    _defineProperty(_this, "_stopTimer", function () {
      if (_this._commitTimer) {
        clearTimeout(_this._commitTimer); //stop any existing timer
        _this._commitTimer = null;
      }
    });
    //Start or reset the existing timer, calling the "commit" function on timeout
    _defineProperty(_this, "_resetTimer", function () {
      _this._stopTimer();
      _this._commitTimer = setTimeout(function () {
        _this.commit(_this.get());
        _this.autoAcceptIfNeeded();
      }, _this._commitTimeout);
    });
    _defineProperty(_this, "_infinityPressed", function () {
      _this.change(_this._infinityText);
      _this._resetTimer();
    });
    if (props.hasInfinity) _this._hasInfinity = props.hasInfinity;
    _this._isNumeric = true;
    if (!props.textAlign) _this._textAlign = 'center';
    if (props.increment && props.increment > 0) _this._increment = props.increment;
    if (props.initialValue || props.initialValue === 0) {
      //is a number
      _this.state.text = _this.interpretVal(props.initialValue);
      _this._initialValue = _this.state.text;
    }
    if (props.commitTimeout) _this._commitTimeout = props._commitTimeout;
    if (props.justify) _this._justify = props.justify;
    if (props.hasNegative) _this._hasNegative = props.hasNegative;
    if (props.infinityText) _this._infinityText = props.infinityText;
    _this.plusPressed = _this.plusPressed.bind(_this);
    _this.minusPressed = _this.minusPressed.bind(_this);
    _this.parseText = _this.parseText.bind(_this);
    _this.interpretVal = _this.interpretVal.bind(_this);
    _this.stringForVal = _this.stringForVal.bind(_this);
    _this.state.text = _this.stringForVal(props.initialValue);
    _this._initialText = _this.stringForVal(props.initialValue);
    return _this;
  }
  _inherits(ManageNumericField, _ManageTextField);
  return _createClass(ManageNumericField, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._stopTimer();
    }
  }, {
    key: "parseText",
    value: function parseText(text) {
      return parseInt(text);
    }

    //Override!
  }, {
    key: "set",
    value: function set(val) {
      _superPropGet(ManageNumericField, "set", this, 3)([this.stringForVal(val)]);
    }
  }, {
    key: "interpretVal",
    value: function interpretVal(text) {
      if (text === null || text === undefined) {
        if (this._hasInfinity) return this._infinityText;else return 0;
      }
      var newInt = this.parseText(text);
      if (newInt < 0 && !this._hasNegative) {
        //negative values are infinity if we don't have negative
        return this._infinityText;
      }
      newInt = Math.round(newInt / this._increment) * this._increment;
      if (this.props.minValue != null && newInt < this.props.minValue) newInt = this.props.minValue;
      if (this.props.maxValue != null && newInt > this.props.maxValue) newInt = this.props.maxValue;
      return newInt;
    }

    //Override!
  }, {
    key: "commit",
    value: function commit(text) {
      if (text === this._infinityText && this._hasInfinity) {
        if (this._hasNegative) _superPropGet(ManageNumericField, "commit", this, 3)([null]); //set to infinity (null)
        else _superPropGet(ManageNumericField, "commit", this, 3)([-1]); //set to infinity (-1)
      } else {
        var val = this.parseText(text);
        if (!val && val !== 0 || !this._hasNegative && val < 0) {
          this.reset(); //reset the text field to the original text
          return;
        }
        val = this.interpretVal(val); //set the text to the standard number value
        this.change(val);
        _superPropGet(ManageNumericField, "commit", this, 3)([val]);
      }
    }
  }, {
    key: "minusPressed",
    value: function minusPressed() {
      var text = this.get();
      var newValue;
      if (text === this._infinityText) newValue = 0;else {
        var val = this.parseText(text);
        if (!this._hasNegative && val <= 0)
          //do nothing, can't minus any more
          newValue = 0; //set to zero 
        else newValue = val - this._increment; //subtract increment     
      }
      if (this.props.minValue !== undefined && newValue < this.props.minValue) newValue = this.props.minValue;
      this.change(newValue);
      this._resetTimer();
    }
  }, {
    key: "plusPressed",
    value: function plusPressed() {
      var text = this.get();
      var newValue;
      if (text === this._infinityText) newValue = 0;else {
        var val = this.parseText(text);
        newValue = val + this._increment; //add increment                  
      }
      if (this._maxValue !== undefined && newValue > this._maxValue) newValue = this._maxValue;
      this.change(newValue);
      this._resetTimer();
    }
  }, {
    key: "render",
    value: function render() {
      //Render the increment buttons surrounded by the (super's) text field
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: this._justify,
          alignItems: 'center'
        }
      }, this.props.hideButtons ? null : /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
        disabled: this._isReadOnly(),
        onClick: this.minusPressed,
        style: this.props.style
      }, /*#__PURE__*/_react["default"].createElement(_IndeterminateCheckBox["default"], {
        style: {
          fontSize: 30
        }
      })), _superPropGet(ManageNumericField, "render", this, 3)([]), this.props.hideButtons ? null : /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
        disabled: this._isReadOnly(),
        onClick: this.plusPressed,
        style: this.props.style
      }, /*#__PURE__*/_react["default"].createElement(_AddBox["default"], {
        style: {
          fontSize: 30
        }
      })), this._hasInfinity ? /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
        title: this._infinityText
      }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
        disabled: this._isReadOnly(),
        onClick: this._infinityPressed,
        style: this.props.style
      }, /*#__PURE__*/_react["default"].createElement(_AllInclusive["default"], {
        style: {
          fontSize: 30
        }
      }))) : null);
    }
  }]);
}(_ManageTextField2.ManageTextField);